<template>
  <v-container fluid class="pa-0" id="step12">
    <StationMap :allStations="allStations" hide-view-details :maxHeight="600" :zoom="14" :height="300" />

    <v-toolbar dense dark color="primary">
      <v-toolbar-title>
        <v-icon medium>place</v-icon>
        Location Details
      </v-toolbar-title>
    </v-toolbar>
    <MonitoringFeatureDetails class="mb-2" :editForm="editForm" />

    <v-layout row wrap>
      <v-flex xs12 lg6 class="pb-2">
        <component v-for="(sourceType, index) in leftCards" :key="`sourceTypeComponent-${index}`" :is="SOURCE_TYPE_COMPONENTS[sourceType]" v-bind="{ editForm: editForm, wideForm: cardSetup.wideForm, class: getMarginsClass(index, true) }" />
      </v-flex>
      <v-flex xs12 lg6>
        <component v-for="(sourceType, index) in rightCards" :key="`sourceTypeComponent-${index}`" :is="SOURCE_TYPE_COMPONENTS[sourceType]" v-bind="{ editForm: editForm, wideForm: cardSetup.wideForm, class: getMarginsClass(index, false) }" />
      </v-flex>
    </v-layout>
    <component v-if="isLastUnevenCard(sourceTypes.length-1)" :is="SOURCE_TYPE_COMPONENTS[sourceTypes[sourceTypes.length-1]]" v-bind="{ editForm: editForm, wideForm: cardSetup.wideForm }" />

    <v-card-actions v-if="isTenantAdmin">
      <v-btn v-if="!editForm" @click="editForm = true" color="warning" large>
        <v-icon left>edit</v-icon>
        {{ $t("Button.Edit_Station_Information") }}
      </v-btn>
      <v-btn v-else @click="editForm = false" color="primary" large>
        <v-icon left>done</v-icon>
        {{ $t("Button.Done") }}
      </v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
  import MonitoringFeatureDetails from './MonitoringFeatureDetails'

  import ContinuousAquariusDetails from '../DataSources/ContinuousAquariusData/ContinuousAquariusDetails'
  import DiscreteEnvirodataDetails from '../DataSources/DiscreteEnvirodata/DiscreteEnvirodataDetails'
  import VegetativeMonitoringEnvirodataDetails from '../DataSources/VegetativeMonitoringEnviroData/VegetativeMonitoringEnviroDataDetails'
  import SurveyEnvirodataDetails from '../DataSources/SurveyEnvirodata/SurveyEnvirodataDetails'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  import StationUtil from '@/components/mixins/StationUtil'

  import StationMap from '@/components/Map'

  import {
    SOURCE_TYPES,
    SOURCE_TYPES_ON_MAP,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const authenticate = createNamespacedHelpers('authenticate')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')

  export default {
    components: {
      MonitoringFeatureDetails,
      StationMap,
      ContinuousAquariusDetails,
      DiscreteEnvirodataDetails,
      VegetativeMonitoringEnvirodataDetails,
      SurveyEnvirodataDetails,
    },
    mixins: [StationUtil],
    data() {
      return {
        SOURCE_TYPES,
        editForm: false,
        recentPhoto: {},
        SOURCE_TYPE_COMPONENTS: {
          [SOURCE_TYPES.continuousAquarius]: 'ContinuousAquariusDetails',
          [SOURCE_TYPES.discreteEnvirodata]: 'DiscreteEnvirodataDetails',
          [SOURCE_TYPES.vegetativeMonitoringEnvirodata]: 'VegetativeMonitoringEnvirodataDetails',
          [SOURCE_TYPES.surveysEnvirodata]: 'SurveyEnvirodataDetails',
        },
      }
    },
    computed: {
      ...authenticate.mapGetters(['isTenantAdmin']),
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceIndexByType', 'currentFeatureDataSourceIndexByType',
        'currentFeatureDataSources',
      ]),
      ...dataSources.mapGetters(['dataSourceIndex']),
      leftCards() {
        return this.sourceTypes.filter((st, index) => index % this.sourceTypes.length == 0 && !this.isLastUnevenCard(
          index))
      },
      rightCards() {
        return this.sourceTypes.filter((st, index) => index % this.sourceTypes.length == 1 && !this.isLastUnevenCard(
          index))
      },
      cardSetup() {
        switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md':
          return {
            wideForm: false,
            leftSideSpacing: 'mr-3 mb-4',
            rightSideSpacing: 'ml-3 mb-4',
          }

        case 'lg':
        case 'xl':
          return {
            wideForm: true,
            leftSideSpacing: 'mr-2 mb-3',
            rightSideSpacing: 'ml-2 mb-3',
          }
        }
      },
      allStations() {
        let stations = []

        SOURCE_TYPES_ON_MAP.forEach(sourceType => {
          let dataSource = this.currentFeatureDataSourceIndexByType[sourceType]
          if (!dataSource) return

          let station = this.dataSourceIndex[sourceType][dataSource.SourceId]
          if (!station) return

          let mappedStation = {
            ...station,
            SourceType: sourceType,
          }

          stations.push(mappedStation)
        })

        return stations
      },
      sourceTypes() {
        let result = this.currentFeatureDataSources.map(fds => fds.SourceType).sort()

        let firstFeatureDataSource = this.currentFeatureDataSources[0]
        if (!firstFeatureDataSource) return result

        return result
      },
    },
    methods: {
      getMarginsClass(index, isLeftSide) {
        let cardSetup = this.cardSetup

        let isLastUnevenCard = this.isLastUnevenCard(index)

        return {
          [cardSetup.leftSideSpacing]: !isLastUnevenCard && isLeftSide && cardSetup.wideForm,
          [cardSetup.rightSideSpacing]: !isLastUnevenCard && !isLeftSide && cardSetup.wideForm,
        }
      },
      isLastUnevenCard(index) {
        return index == (this.sourceTypes.length - 1) && (this.sourceTypes.length) % 2 == 1
      },
    },
  }
</script>